module.exports = __webpack_public_path__ + "img/12.a635c717.png";